// Copy-pasted from:
// https://github.com/davidramos-om/zipcelx-on-steroids/blob/master/src/statics/workbook.xml.rels.js

export default function generateWorkbookXmlRels({ sheetId }) {
    return (
        '<?xml version="1.0" ?>' +
        '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
        `<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/table" Target="../tables/table${sheetId}.xml" />` +
        '</Relationships>'
    );
}
